const DomainUrl = "https://backend.cfmatt.contrackfm.com";
// const DomainUrl = "https://cfm-hr-staging-vm1.bit68-infra.com";

export default DomainUrl;

// Live: (Production Environment)
// https://backend-cfm-hr-live.bit68.com > DomainUrl
// https://cfmatt.contrackfm.com > CfmUrl

// Staging:
// https://backend-cfm-hr.bit68.com > DomainUrl
// https://cfm-hr-portal.bit68.com > CfmUrl
